/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CatalogConfigDto } from '../model/catalogConfigDto';
import { CatalogInstallationDto } from '../model/catalogInstallationDto';
import { CatalogSubmissionDto } from '../model/catalogSubmissionDto';
import { InstallationOverviewDto } from '../model/installationOverviewDto';
import { PreflightResultDto } from '../model/preflightResultDto';
import { ProvideRequest } from '../model/provideRequest';
import { SubmitRequest } from '../model/submitRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CatalogControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCatalogConfig(observe?: 'body', reportProgress?: boolean): Observable<CatalogConfigDto>;
    public getCatalogConfig(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CatalogConfigDto>>;
    public getCatalogConfig(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CatalogConfigDto>>;
    public getCatalogConfig(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CatalogConfigDto>('get',`${this.basePath}/workflows/catalog/config`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listCatalogInstallations(observe?: 'body', reportProgress?: boolean): Observable<Array<InstallationOverviewDto>>;
    public listCatalogInstallations(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InstallationOverviewDto>>>;
    public listCatalogInstallations(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InstallationOverviewDto>>>;
    public listCatalogInstallations(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<InstallationOverviewDto>>('get',`${this.basePath}/workflows/catalog/installations`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param itemType 
     * @param sourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listCatalogSubmissions(itemType?: string, sourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CatalogSubmissionDto>>;
    public listCatalogSubmissions(itemType?: string, sourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CatalogSubmissionDto>>>;
    public listCatalogSubmissions(itemType?: string, sourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CatalogSubmissionDto>>>;
    public listCatalogSubmissions(itemType?: string, sourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (itemType !== undefined && itemType !== null) {
            queryParameters = queryParameters.set('itemType', <any>itemType);
        }
        if (sourceId !== undefined && sourceId !== null) {
            queryParameters = queryParameters.set('sourceId', <any>sourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CatalogSubmissionDto>>('get',`${this.basePath}/workflows/catalog/submissions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param itemType 
     * @param sourceId 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public preflightCatalogSubmission(itemType: string, sourceId: string, projectId?: number, observe?: 'body', reportProgress?: boolean): Observable<PreflightResultDto>;
    public preflightCatalogSubmission(itemType: string, sourceId: string, projectId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PreflightResultDto>>;
    public preflightCatalogSubmission(itemType: string, sourceId: string, projectId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PreflightResultDto>>;
    public preflightCatalogSubmission(itemType: string, sourceId: string, projectId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (itemType === null || itemType === undefined) {
            throw new Error('Required parameter itemType was null or undefined when calling preflightCatalogSubmission.');
        }

        if (sourceId === null || sourceId === undefined) {
            throw new Error('Required parameter sourceId was null or undefined when calling preflightCatalogSubmission.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (itemType !== undefined && itemType !== null) {
            queryParameters = queryParameters.set('itemType', <any>itemType);
        }
        if (sourceId !== undefined && sourceId !== null) {
            queryParameters = queryParameters.set('sourceId', <any>sourceId);
        }
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PreflightResultDto>('get',`${this.basePath}/workflows/catalog/preflight`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public provideFromCatalog(body: ProvideRequest, observe?: 'body', reportProgress?: boolean): Observable<Array<CatalogInstallationDto>>;
    public provideFromCatalog(body: ProvideRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CatalogInstallationDto>>>;
    public provideFromCatalog(body: ProvideRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CatalogInstallationDto>>>;
    public provideFromCatalog(body: ProvideRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling provideFromCatalog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<CatalogInstallationDto>>('post',`${this.basePath}/workflows/catalog/provide`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public submitToCatalog(body: SubmitRequest, observe?: 'body', reportProgress?: boolean): Observable<Array<CatalogSubmissionDto>>;
    public submitToCatalog(body: SubmitRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CatalogSubmissionDto>>>;
    public submitToCatalog(body: SubmitRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CatalogSubmissionDto>>>;
    public submitToCatalog(body: SubmitRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling submitToCatalog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<CatalogSubmissionDto>>('post',`${this.basePath}/workflows/catalog/submissions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
